"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
exports.__esModule = true;
exports.PFAHeroDefaultProps = exports.PFAHero = void 0;
var _pfaHero = _interopRequireDefault(require("./components/pfa-hero"));
exports.PFAHero = _pfaHero["default"];
var _pfaHero2 = _interopRequireDefault(require("./components/pfa-hero.props/pfa-hero.defaultProps"));
exports.PFAHeroDefaultProps = _pfaHero2["default"];